'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { Button } from '@workspace/ui/components/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@workspace/ui/components/dialog';
import { Lock } from 'lucide-react';
import { getEorHref } from '@/lib/eor-app-url';

interface FeatureLockedDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function FeatureLockedDialog({ open, onOpenChange }: FeatureLockedDialogProps) {
  const handleUpgrade = () => {
    onOpenChange(false);
    window.location.assign(getEorHref('/settings'));
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent size="sm">
        <DialogHeader className="sr-only">
          <DialogTitle>Feature locked</DialogTitle>
          <DialogDescription>
            Upgrade your plan to access this feature and many more!
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col space-y-6">
          <div className="flex h-16 w-16 items-center justify-center">
            <Lock className="h-14 w-14 text-neutral-200 dark:text-neutral-100" strokeWidth={2} />
          </div>

          <div className="space-y-2 text-left">
            <p className="text-[32px] leading-10 font-bold text-neutral-200 dark:text-neutral-100">
              Feature locked
            </p>
          </div>

          <p className="text-grey-800 dark:text-grey-400 text-left text-sm leading-relaxed">
            Upgrade your plan to access this feature and many more!
          </p>

          <Button variant="primary" className="w-full" onClick={handleUpgrade}>
            Upgrade
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
